import type { PropsWithChildren } from "react";
import React from "react";

import { verticalProductCardStyle } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = PropsWithChildren & {
  product: ProductCardDataType;
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>
  ) => void;
  disableLink?: boolean;
};

export const VerticalProductCardRoot = React.forwardRef<
  HTMLDivElement | HTMLAnchorElement,
  Props
>(({ children, product, onClick, disableLink = false }, ref) => {
  if (disableLink) {
    return (
      <div
        ref={ref as React.Ref<HTMLDivElement>}
        title={product.productName}
        className={verticalProductCardStyle}
        onClick={onClick}
        data-testid="vertical-product-card"
      >
        {children}
      </div>
    );
  }

  if (onClick) {
    return (
      <a
        ref={ref as React.Ref<HTMLAnchorElement>}
        href={product.href}
        title={product.productName}
        className={verticalProductCardStyle}
        onClick={onClick}
        data-testid="vertical-product-card"
      >
        {children}
      </a>
    );
  }

  return (
    <a
      ref={ref as React.Ref<HTMLAnchorElement>}
      href={product.href}
      title={product.productName}
      className={verticalProductCardStyle}
      data-testid="vertical-product-card"
    >
      {children}
    </a>
  );
});
